<footer
    class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
>
    <ng-container *transloco="let t">
        <p>
            © <span class="text-black fw-medium">ALTAIR</span> {{t('is-proudly-owned-by')}} <a href="https://intrustsecurity.co" target="_blank">Intrust Security</a>
        </p>
    </ng-container>
</footer>
